export enum ProductEnum {
  MULTAS = 62068,
  MULTAS_PENALIDADE = 62073,
  TAXAS = 6207,
  TAXAS_SERVICO_TRANSPORTE = 62074,
  TAXAS_REGULACAO_TRANSPORTE = 62075,
  TAXAS_SEGUNDA_VIA_PL = 62076,
  TAXAS_OUTORGA = 62077
}

export const listProductEnumAll = [
  { key: 'Multas', value: ProductEnum.MULTAS },
  { key: 'Multas Penalidade', value: ProductEnum.MULTAS_PENALIDADE },
  { key: 'Taxas', value: ProductEnum.TAXAS },
  { key: 'Taxas Serviços Transporte', value: ProductEnum.TAXAS_SERVICO_TRANSPORTE },
  { key: 'Taxas Regulação Transporte', value: ProductEnum.TAXAS_REGULACAO_TRANSPORTE },
  { key: 'Taxas Segunda Via Passe Livre', value: ProductEnum.TAXAS_SEGUNDA_VIA_PL },
  { key: 'Taxas Outorga', value: ProductEnum.TAXAS_OUTORGA }
]



export const ProductEnumAll = listProductEnumAll.sort((a, b) => {
  if (a.key < b.key) {
    return -1; 
  }
  if (a.key > b.key) {
    return 1;
  }
  return 0;
});
